export const POSITION_CATEGORIES = [
  "Engineering",
  "Production",
  "Quality",
  "Sales & Marketing",
  "Procurement",
  "Business Development",
  "Administration",
  "Internship / Trainee",
];
